import React, { Component } from 'react';
import * as TimeUtil from './time';
import { addPrefixCss, formatCss } from './prefix';

const DATE_HEIGHT = 40;                              
const DATE_LENGTH = 10;                              
const MIDDLE_INDEX = Math.floor(DATE_LENGTH / 2);    
const MIDDLE_Y = - DATE_HEIGHT * MIDDLE_INDEX;       

const isUndefined = val => typeof val === 'undefined';

class DatePickerItem extends Component {
    constructor(props) {
        super(props);
        this.animating = false;                 
        this.touchY = 0;                        
        this.translateY = 0;                    
        this.currentIndex = MIDDLE_INDEX;       
        this.moveDateCount = 0;                 
        this._moveToTimer = null;

        this.state = {
            translateY: MIDDLE_Y,
            marginTop: (this.currentIndex - MIDDLE_INDEX) * DATE_HEIGHT,
        };

        this.renderDatepickerItem = this.renderDatepickerItem.bind(this);
        this.handleContentTouch = this.handleContentTouch.bind(this);
        this.handleContentMouseDown = this.handleContentMouseDown.bind(this);
        this.handleContentMouseMove = this.handleContentMouseMove.bind(this);
        this.handleContentMouseUp = this.handleContentMouseUp.bind(this);
    }

    UNSAFE_componentWillMount() {
        this._iniDates(this.props);
    }

    componentDidMount() {
        const viewport = this.viewport;
        viewport.addEventListener('touchstart', this.handleContentTouch, false);
        viewport.addEventListener('touchmove', this.handleContentTouch, false);
        viewport.addEventListener('touchend', this.handleContentTouch, false);
        viewport.addEventListener('mousedown', this.handleContentMouseDown, false);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.value === this.props.value) {
            return;
        }
        this._iniDates(nextProps.value);
        this.currentIndex = MIDDLE_INDEX;
        this.setState({
            translateY: MIDDLE_Y,
            marginTop: (this.currentIndex - MIDDLE_INDEX) * DATE_HEIGHT,
        });
    }

    shallowEqual(prev, next) {
        if (prev === next) return true;
        const prevKeys = Object.keys(prev);
        const nextKeys = Object.keys(next);
    
        if (prevKeys.length !== nextKeys.length) return false;
    
        return prevKeys.every((key) => {
            return prev.hasOwnProperty(key) && prev[key] === next[key];
        });
    }
    shouldComponentUpdate(nextProps, nextState) {
        return nextProps.value !== this.props.value ||
            !this.shallowEqual(nextState, this.state);
    }

    componentWillUnmount() {
        const viewport = this.viewport;
        viewport.removeEventListener('touchstart', this.handleContentTouch, false);
        viewport.removeEventListener('touchmove', this.handleContentTouch, false);
        viewport.removeEventListener('touchend', this.handleContentTouch, false);
        viewport.removeEventListener('mousedown', this.handleContentMouseDown, false);
        
        clearTimeout(this._moveToTimer);
    }

    _iniDates(data) {
        const typeName = this.props.type;
        let dataValue = ''
        if(data.value){
            if(typeName === 'sphere') dataValue = data.value.split(" ")[0]
            if(typeName === 'cylinder') dataValue = data.value.split(" ")[1]
            if(typeName === 'count') dataValue = data.value.split(" ")[2]
        } else if(typeof data === 'string' && data.includes(" ")){
            if(typeName === 'sphere') dataValue = data.split(" ")[0]
            if(typeName === 'cylinder') dataValue = data.split(" ")[1]
            if(typeName === 'count') dataValue = data.split(" ")[2]
        } else {
            dataValue = data;
        }
        let dates = Array(...Array(DATE_LENGTH))
            .map((value, index) => {
                return TimeUtil["nextValue"](dataValue, typeName, (index - MIDDLE_INDEX) * this.props.step);
            })

        this.setState({ dates });
    }

    _updateDates(direction) {
        const typeName = this.props.type;
        const { dates } = this.state;
        if (direction === 1) {
            this.currentIndex ++;
            this.setState({
                dates: [
                    ...dates.slice(1),
                    TimeUtil["nextValue"](dates[dates.length - 1], typeName, +this.props.step),
                ],
                marginTop: (this.currentIndex - MIDDLE_INDEX) * DATE_HEIGHT,
            });
        } else {
            this.currentIndex --;
            this.setState({
                dates: [
                    TimeUtil["nextValue"](dates[0], typeName, -this.props.step),
                    ...dates.slice(0, dates.length - 1),
                ],
                marginTop: (this.currentIndex - MIDDLE_INDEX) * DATE_HEIGHT,
            });
        }
    }

    _checkIsUpdateDates(direction, translateY) {
        return direction === 1 ?
            this.currentIndex * DATE_HEIGHT + DATE_HEIGHT / 2 < -translateY :
            this.currentIndex * DATE_HEIGHT - DATE_HEIGHT / 2 > -translateY;
    }

    _clearTransition(obj) {
        addPrefixCss(obj, { transition: '' });
    }

    _moveToNext(direction) {
        this._moveTo(this.currentIndex);
    }

    _moveTo(currentIndex) {
        this.animating = true;

        addPrefixCss(this.refs.scroll, { transition: 'transform .2s ease-out' });

        this.setState({
            translateY: -currentIndex * DATE_HEIGHT,
        });

        // NOTE: There is no transitionend, setTimeout is used instead.
        this._moveToTimer = setTimeout(() => {
            this.animating = false;
            this.props.onSelect(this.state.dates[MIDDLE_INDEX], this.props.type);
            this._clearTransition(this.refs.scroll);
        }, 200);
    }

    handleStart(event) {
        this.touchY =
            (!isUndefined(event.targetTouches) &&
             !isUndefined(event.targetTouches[0])) ?
            event.targetTouches[0].pageY :
            event.pageY;

        this.translateY = this.state.translateY;
        this.moveDateCount = 0;
    }


    handleMove(event) {
        const touchY =
            (!isUndefined(event.targetTouches) &&
             !isUndefined(event.targetTouches[0])) ?
            event.targetTouches[0].pageY :
            event.pageY;

        const dir = touchY - this.touchY;
        const translateY = this.translateY + dir;
        const direction = dir > 0 ? -1 : 1;

        if (this._checkIsUpdateDates(direction, translateY)) {
            this.moveDateCount = direction > 0 ? this.moveDateCount + 1 : this.moveDateCount - 1;
            this._updateDates(direction);
        }

        this.setState({ translateY });
    }

    handleEnd(event) {
        const touchY = event.pageY || event.changedTouches[0].pageY;
        const dir = touchY - this.touchY;
        const direction = dir > 0 ? -1 : 1;
        this._moveToNext(direction);
    }

    handleContentTouch(event) {
        event.preventDefault();
        if (this.animating) return;
        if (event.type === 'touchstart') {
            this.handleStart(event);
        } else if (event.type === 'touchmove') {
            this.handleMove(event);
        } else if (event.type === 'touchend') {
            this.handleEnd(event);
        }
    }

    handleContentMouseDown(event) {
        if (this.animating) return;
        this.handleStart(event);
        document.addEventListener('mousemove', this.handleContentMouseMove);
        document.addEventListener('mouseup', this.handleContentMouseUp);
    }

    handleContentMouseMove(event) {
        if (this.animating) return;
        this.handleMove(event);
    }

    handleContentMouseUp(event) {
        if (this.animating) return;
        this.handleEnd(event);
        document.removeEventListener('mousemove', this.handleContentMouseMove);
        document.removeEventListener('mouseup', this.handleContentMouseUp);
    }

    renderDatepickerItem(date, index) {

        return (
            <li key={index} >
                {date}
            </li>
        );
    }

    render() {
        const scrollStyle = formatCss({
            transform: `translateY(${this.state.translateY}px)`,
            marginTop: this.state.marginTop,
        });

        return (
            <div className="datepicker-col-1">
                <div
                    ref={viewport => this.viewport = viewport} // eslint-disable-line
                    className="datepicker-viewport">
                    <div className="datepicker-wheel">
                        <ul
                            ref="scroll"
                            className="datepicker-scroll"
                            style={scrollStyle}>
                            {this.state.dates.map(this.renderDatepickerItem)}
                        </ul>
                    </div>
                </div>
            </div>
        );
    }
}

export default DatePickerItem;
